export const EXPLORE_GEO_PROMPT_KEY = 'events-explore-geo-prompted'
export const EXPLORE_GEO_GRANTED = 'granted'
export const EXPLORE_GEO_DECLINED = 'declined'

export function markExploreGeoGranted() {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(EXPLORE_GEO_PROMPT_KEY, EXPLORE_GEO_GRANTED)
}

export function markExploreGeoDeclined() {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(EXPLORE_GEO_PROMPT_KEY, EXPLORE_GEO_DECLINED)
}

export function getExploreGeoPromptFlag(): string | null {
  if (typeof window === 'undefined') return null
  return sessionStorage.getItem(EXPLORE_GEO_PROMPT_KEY)
}

/** True when we should not show the Yes/No opt-in modal again this session. */
export function hasAnsweredExploreGeoPrompt(): boolean {
  const flag = getExploreGeoPromptFlag()
  return flag === EXPLORE_GEO_GRANTED || flag === EXPLORE_GEO_DECLINED || flag === '1'
}
